export enum ClientType {
    ANDROID = "ANDROID",
    PARKOR_MOBILE = "PARKOR_MOBILE",
    WEB = "WEB"
  }